<div class="layout-column full-height">
  <cdk-virtual-scroll-viewport [itemSize]="isMinimizedData ? 70 : 110"
                               class="flex viewport"
                               (scroll)="getNextBatch()">

    <app-agents-list-item *cdkVirtualFor="let agent of agents"
                          [agent]="agent"
                          [isSelected]="selectedAgentId === agent.id"
                          [isItineraryMode]="isItineraryMode"
                          [enableItineraryButton]="enableItineraryButton"
                          [enableDriverButton]="enableDriverButton"
                          [enableChangeDriverStatus]="enableChangeDriverStatus"
                          [isMinimizedData]="isMinimizedData"
                          (onAgentSelect)="onAgentSelect.emit($event)"
                          (onChangeStatus)="onChangeStatus.emit($event)"
                          (onItineraryClick)="onItineraryClick.emit($event)">

    </app-agents-list-item>

  </cdk-virtual-scroll-viewport>
</div>
